import { createSvgIcon } from '@mui/material/utils'

const ConfirmForkKnife = createSvgIcon(
  <>
    <path
      d="M85.23 60.24V4.60999C87.77 4.99999 89.5 8.55999 89.5 12.46V38.24H85.23"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M13.54 6.5L12.93 22.6L8.99999 26.31L9.36999 59.78H4.23999"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M0.5 6.5L1.11 22.6L5.04 26.31L4.24 59.78" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M9 6.5V19.58" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M5.04004 6.5V19.58" stroke="#204ECF" strokeLinejoin="round" />
    <path
      d="M73.39 66.44V11.26L62.63 0.5H22.38V66.44H50.03H73.39Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M62.63 0.5V11.26H73.39" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M38.9299 19.58H62.4099" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M31.72 19.58H34.94" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M38.9299 27.13H62.4099" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M31.72 27.13H34.94" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M38.9299 34.67H62.4099" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M31.72 34.67H34.94" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M39.1 51.31L44.22 56.44L57.11 43.56" stroke="#204ECF" strokeMiterlimit="10" />
  </>,
  'ConfirmForkKnife'
)

export default ConfirmForkKnife
